import DTRBIIssueLoyaltyPointsThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTRBIIssueLoyaltyPointsThenSendMacroNode/DTRBIIssueLoyaltyPointsThenSendMacroNode';
import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';

const RbiIssueLoyaltyPointsThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRBIIssueLoyaltyPointsThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'Loyalty points have been issued.'}
    />
  );
};

export default RbiIssueLoyaltyPointsThenSendMacro;
